import { CompositeEncoderknecpkexzn3v as CompositeEncoder } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/encoding/Encoding.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { AbstractEncoder2gxtu3xmy3f8j as AbstractEncoder } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/encoding/AbstractEncoder.mjs';
import { StringDeferringEncoder2g68f2tkdfmtv as StringDeferringEncoder } from './StringDeferringEncoder.mjs';
import { Error3ofk6owajcepa as Error_0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { LIST_getInstancey7k5h8d5cvxt as LIST_getInstance } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { NotImplementedErrorfzlkpv14xxr8 as NotImplementedError } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Standard.mjs';
import {
  Companion_getInstance143t5fwt3jdp8 as Companion_getInstance,
  appendCsvr9yu6rqb1co7 as appendCsv,
} from './CsvConfig.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { sequenceOf1mtha40gp6gat as sequenceOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/sequences/Sequences.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { asSequence2phdjljfh9jhx as asSequence } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CsvFormat$TopListEncoder$beginStructure$1$beginStructure$1Class;
function CsvFormat$TopListEncoder$beginStructure$1$beginStructure$1() {
  if (CsvFormat$TopListEncoder$beginStructure$1$beginStructure$1Class === VOID) {
    class $ {
      constructor($og, this$0) {
        this.ker_1 = $og;
        this.ler_1 = this$0;
        this.jer_1 = $og;
      }
      m13(descriptor) {
        this.ler_1.mer_1(this.ker_1.qer_1);
      }
      h15(descriptor, index) {
        return this.jer_1.h15(descriptor, index);
      }
      s14(descriptor, index, value) {
        this.jer_1.s14(descriptor, index, value);
      }
      t14(descriptor, index, value) {
        this.jer_1.t14(descriptor, index, value);
      }
      u14(descriptor, index, value) {
        this.jer_1.u14(descriptor, index, value);
      }
      z14(descriptor, index, value) {
        this.jer_1.z14(descriptor, index, value);
      }
      v14(descriptor, index, value) {
        this.jer_1.v14(descriptor, index, value);
      }
      w14(descriptor, index, value) {
        this.jer_1.w14(descriptor, index, value);
      }
      x14(descriptor, index, value) {
        this.jer_1.x14(descriptor, index, value);
      }
      y14(descriptor, index, value) {
        this.jer_1.y14(descriptor, index, value);
      }
      a15(descriptor, index, value) {
        this.jer_1.a15(descriptor, index, value);
      }
      b15(descriptor, index) {
        return this.jer_1.b15(descriptor, index);
      }
      c15(descriptor, index, serializer, value) {
        this.jer_1.c15(descriptor, index, serializer, value);
      }
      d15(descriptor, index, serializer, value) {
        this.jer_1.d15(descriptor, index, serializer, value);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [CompositeEncoder()]);
    CsvFormat$TopListEncoder$beginStructure$1$beginStructure$1Class = $;
  }
  return CsvFormat$TopListEncoder$beginStructure$1$beginStructure$1Class;
}
var CsvFormat$TopListEncoder$beginStructure$1Class;
function CsvFormat$TopListEncoder$beginStructure$1() {
  if (CsvFormat$TopListEncoder$beginStructure$1Class === VOID) {
    class $ extends AbstractEncoder() {
      static ver(this$0, this$1, $box) {
        if ($box === VOID)
          $box = {};
        $box.ter_1 = this$0;
        $box.uer_1 = this$1;
        return this.d14($box);
      }
      mz() {
        return this.ter_1.bes_1.wer_1;
      }
      l13(descriptor) {
        var og = new (StringDeferringEncoder())(this.ter_1.bes_1, false);
        return new (CsvFormat$TopListEncoder$beginStructure$1$beginStructure$1())(og, this.uer_1);
      }
      f14(value) {
        (new (StringDeferringEncoder())(this.ter_1.bes_1, false)).o4z('', value);
      }
    }
    initMetadataForClass($);
    CsvFormat$TopListEncoder$beginStructure$1Class = $;
  }
  return CsvFormat$TopListEncoder$beginStructure$1Class;
}
var TopListEncoderClass;
function TopListEncoder() {
  if (TopListEncoderClass === VOID) {
    class $ extends AbstractEncoder() {
      static des($outer, onComplete, $box) {
        if ($box === VOID)
          $box = {};
        $box.ner_1 = $outer;
        var $this = this.d14($box);
        $this.mer_1 = onComplete;
        return $this;
      }
      mz() {
        return this.ner_1.bes_1.wer_1;
      }
      l13(descriptor) {
        if (!equals(descriptor.s11(), LIST_getInstance()))
          throw Error_0().de();
        return CsvFormat$TopListEncoder$beginStructure$1().ver(this.ner_1, this);
      }
      ees(value) {
        throw NotImplementedError().qd();
      }
      f14(value) {
        return this.ees(value);
      }
    }
    initMetadataForClass($, 'TopListEncoder');
    TopListEncoderClass = $;
  }
  return TopListEncoderClass;
}
var CsvFormatClass;
function CsvFormat() {
  if (CsvFormatClass === VOID) {
    class $ {
      constructor(stringDeferringConfig, csvConfig) {
        csvConfig = csvConfig === VOID ? Companion_getInstance().xeq_1 : csvConfig;
        this.bes_1 = stringDeferringConfig;
        this.ces_1 = csvConfig;
      }
      mz() {
        return this.bes_1.wer_1;
      }
      x27(serializer, value) {
        var tmp0_subject = serializer.az().s11();
        var tmp;
        if (equals(tmp0_subject, LIST_getInstance())) {
          // Inline function 'kotlin.text.buildString' call
          // Inline function 'kotlin.apply' call
          var this_0 = StringBuilder().d1();
          var maps = ArrayList().w();
          serializer.oz(TopListEncoder().des(this, (it) => {
            // Inline function 'kotlin.collections.plusAssign' call
            maps.v(it);
            return Unit_instance;
          }), value);
          appendCsv(this_0, asSequence(maps), this.ces_1);
          tmp = this_0.toString();
        } else {
          // Inline function 'kotlin.text.buildString' call
          // Inline function 'kotlin.apply' call
          var this_1 = StringBuilder().d1();
          // Inline function 'kotlin.apply' call
          var this_2 = new (StringDeferringEncoder())(this.bes_1, false);
          this_2.nz(serializer, value);
          // Inline function 'kotlin.let' call
          var it = this_2.qer_1;
          var tmp$ret$7 = sequenceOf([it]);
          appendCsv(this_1, tmp$ret$7);
          tmp = this_1.toString();
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'CsvFormat');
    CsvFormatClass = $;
  }
  return CsvFormatClass;
}
//region block: exports
export {
  CsvFormat as CsvFormat2d7d3ollhiney,
};
//endregion

//# sourceMappingURL=CsvFormat.mjs.map
